import './plugins';
import './components';
import Hc from './Hc';

// Boot Hc
window.Hc = new Hc();
